import style from "./style.module.scss";
import { useState, useEffect } from "react";
import LandingPageFooter from "@/src/views/products/landing/features/success/footer";
import { useDispatch, useSelector } from "react-redux";
import { getIpAddressDatas } from "../../../../../application/actions/userTracking";
import ModalChangePassword from "../../features/success/ModalChangePassword";
import LandingOverview from "../../features/success/LandingOverview";
import ModalDetailProduct from "../../features/success/ModalDetailProduct";
import LandingServices from "../../features/success/LandingServices";
import { callToActionAction, headlineAction, listLayananAction, listProdukAction, listWordStylingAction, resetLoginData } from "@/src/application/actions/loginPage";
import Button from "@/src/views/components/Button";
import LandingLogin from "../../features/success/login/LandingLogin";
import LandingProducts from "../../features/success/LandingProducts";
import LandingCallToAction from "../../features/success/LandingCallToAction";
import LoaderGeneralLogin from "@/src/views/components/Loaders/LoaderGeneralLogin";
import Alert from "@/src/views/components/Alert";
import { fetchAnnouncement } from "@/src/services/api/loginPage";

export default function LandingPage({ id = "" }: { id?: string }) {

  const {
    listWordStyling,
    headline, isLoadingHeadline,
    listLayanan, isLoadingListLayanan,
    listProduk, isLoadingListProduk,
    callToAction, isLoadingCallToAction,
    listAnnouncement, isLoadingListAnnouncement,
  } = useSelector(
    (state: any) => state?.loginPage
  );
  const dispatch = useDispatch();
  const [state, setState] = useState({
    openLogin: false,
    tab: 0,
    modalDetail: false,
  });

  const [getAnnouncement, setGetAnnouncement] = useState<any>(null);

  // const clearCacheData = () => {
  //   caches?.keys()?.then((names) => {
  //     names?.forEach((name) => {
  //       caches?.delete(name)
  //     })
  //   })
  //   cookie.remove('user')
  //   sessionStorage.clear()
  //   localStorage.clear()
  // }

  useEffect(() => {
    // clearCacheData()
    // dispatch(getIpAddressDatas());
    dispatch(listWordStylingAction());
    dispatch(headlineAction());
    dispatch(listLayananAction());
    dispatch(listProdukAction());
    dispatch(callToActionAction());
  }, []);

  useEffect(() => {
    fetchAnnouncement()
      .then((res: any) => {
        setGetAnnouncement(res)
      })
      .catch((err: any) => {
        console.log('err', err)
      });
  }, [])

  const handleLoginButton = () => {
    setState(prev => {
      if (!prev.openLogin) {
        dispatch(resetLoginData());
      }
      return { ...prev, openLogin: !prev.openLogin };
    });
  };

  const handleCloseModalDetail = () => {
    setState({ ...state, modalDetail: false });
  };

  if (isLoadingHeadline || isLoadingListLayanan ||
    // isLoadingListProduk 
    isLoadingCallToAction) {
    return <LoaderGeneralLogin />
  }

  return (
    <div className={style.container}>
      {/* section header */}
      <header className={style.header} id="landing-page-header">
        <img
          id={"image-logo-bribrain"}
          className={style.image_header}
          src={`${process.env.NEXT_PUBLIC_IMAGES}/bribrain-logo.svg`}
          alt="logo-header"
        />
        <Button
          size="modal"
          text="Login"
          onClick={handleLoginButton}
        />
      </header>
      {/* end section header */}
      {getAnnouncement && getAnnouncement.data && (
        <div className={style.alert_container}>
          {getAnnouncement.data.map((item: any, index: number) => (
            item.announcement && (
              <div key={index} className={style.alert_single}>
                <Alert>
                  {item.announcement}
                </Alert>
              </div>
            )
          ))}
        </div>
      )}

      <LandingOverview
        headline={headline?.data}
        listWordStyling={listWordStyling?.data}
      />
      <LandingServices
        services={listLayanan?.data}
        loading={isLoadingListLayanan}
        listWordStyling={listWordStyling?.data}
      />
      <LandingProducts
        showcases={listProduk?.data?.showcase}
        others={listProduk?.data?.logo}
        total_usecase={listProduk?.data?.total_usecase}
        listWordStyling={listWordStyling?.data}
      />
      <LandingCallToAction
        callToAction={callToAction?.data}
      />
      <LandingPageFooter id={`${id}-${process.env.NEXT_PUBLIC_FOOTER}`} />
      {/* modal login */}
      {state.openLogin && (
        <LandingLogin
          id={`${id}-${process.env.NEXT_PUBLIC_LOGIN}`}
          open={state.openLogin}
          handleClose={handleLoginButton}
        />
      )}
      {/* end modal login */}

      <ModalDetailProduct
        modalState={state.modalDetail}
        handleClose={handleCloseModalDetail}
      />
      <ModalChangePassword />
    </div>
  );
}